define([
	'jquery',
	'handlebars-loader',
	'wcs.context'
], function($, HBLoader, ctx) {

	var DEBUG = false;
	var PLUGIN_IDENTIFIER = 'autoComplete';
	var autoComplete;

	(function(){
		// Define the plugin's prototype and defaults
		autoComplete = {
			defaults: {
				el: ".topnav-search-form",
				dataAttr: "options",
				autocompleteEndpoint: "VFAutoSuggestView"
			},

			init: function() {
				if ( DEBUG ) console.log('initilizing ' + PLUGIN_IDENTIFIER);

				var self = this;
				self.deferred = $.Deferred();

				self.$element = $(self.defaults.el);
				self.metadata = self.$element.data(self.defaults.dataAttr);
				self.config = $.extend( {}, self.defaults, self.metadata );

				self.config.$searchForm = self.$element;

				self.enableAutoComplete();

				self.deferred.resolve();

				return self;
			},

			enableAutoComplete: function() {
				var self = this;

				// check for search form, solr options and autocomplete type of solr
				if(self.config.$searchForm.length > 0 && self.config.$searchForm.data('autocomplete') === true){

					// get url for autocomplete service from global ACTION_URLS or build it using context provider
					var autocompleteURL = window.ACTION_URLS ? window.ACTION_URLS.AUTOCOMPLETE_URL : ctx.getContextRoot() + self.config.autocompleteEndpoint;

					// create the data used for the AJAX request to the PLATFORM SEARCH service
					var data = $.extend( {
						"ajaxParams": {
							url: autocompleteURL,
							data: {
								langId : ctx.getLangId(),
								storeId : ctx.getStoreId(),
								catalogId : ctx.getCatalogId(),
								endpoint : self.config.$searchForm.attr('action')
							}
						}
					}, self.config.$searchForm.data('options'));
					return new HBLoader( data );
				} else {
					return false;
				}
			}
		};
		
		return autoComplete.init();

	})();

	return autoComplete;
});